import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { hideChatMaintenanceIcon } from '@edulastic/common/src/components/ActionHub/actionHubHelpers'
import {
  ChatIconButton,
  NotificationContainer,
  NotificationHeader,
  NotificationTitle,
  IconCircle,
  TitleText,
  CloseButton,
  NotificationMessage,
  SupportLink,
} from './styled'
import { ChatBubbleIcon, ChatBubbleSmallIcon } from './chatMaintenanceIcons'

const ChatMaintenanceIcon = () => {
  const [showNotification, setShowNotification] = useState(false)
  const notificationRef = useRef(null)

  // Read support URL from environment variable
  const supportUrl =
    process.env.REACT_APP_CHAT_SUPPORT_URL ||
    'https://docs.goguardian.com/support/contact-support'

  useEffect(() => {
    if (!showNotification) return

    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        event.target.id !== 'chat-maintenance-icon'
      ) {
        setShowNotification(false)
      }
    }

    // Small delay to prevent immediate close on icon click
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside)
    }, 100)

    return () => {
      clearTimeout(timer)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [showNotification])

  const handleIconClick = () => {
    setShowNotification(!showNotification)
  }

  const handleCloseClick = () => {
    setShowNotification(false)
  }

  return (
    <>
      <ChatIconButton
        id="chat-maintenance-icon"
        onClick={handleIconClick}
        aria-label="Chat Support"
      >
        <ChatBubbleIcon />
      </ChatIconButton>

      {showNotification && (
        <NotificationContainer ref={notificationRef}>
          <NotificationHeader>
            <NotificationTitle>
              <IconCircle>
                <ChatBubbleSmallIcon />
              </IconCircle>
              <TitleText>Chat Support</TitleText>
            </NotificationTitle>
            <CloseButton onClick={handleCloseClick}>&times;</CloseButton>
          </NotificationHeader>
          <NotificationMessage>
            We are currently enhancing our chat experience and it is temporarily
            down for maintenance and expected to be available again within 24
            hours.
          </NotificationMessage>
          <SupportLink
            href={supportUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Support &rarr;
          </SupportLink>
        </NotificationContainer>
      )}
    </>
  )
}

// Function to render the maintenance icon to the DOM
export const showChatMaintenanceIcon = ({ hideLauncher = true } = {}) => {
  // Check if container already exists
  if (document.getElementById('chat-maintenance-container')) {
    return
  }

  // Action Hub opens this icon programmatically; hide it before first paint.
  // Native SF launcher districts (e.g. GCPS) leave the icon visible.
  if (hideLauncher) {
    hideChatMaintenanceIcon()
  }

  // Create container for React component
  const container = document.createElement('div')
  container.id = 'chat-maintenance-container'
  document.body.appendChild(container)

  // Render the React component
  ReactDOM.render(<ChatMaintenanceIcon />, container)
}

export default ChatMaintenanceIcon
